import { createSlice } from "@reduxjs/toolkit";


const responseSlice = createSlice({
    name: 'response',
    initialState: {
        success: null,
        error: null,
        registerError:null,
    },
    reducers: {},
    extraReducers(builder) {
        builder.addCase("response", (state, action) => {
            state.success = action.payload;
        });
        builder.addCase("clear/message", (state, action) => {
            state.success = null;
            state.error= null;
            state.registerError= null;
        });
        builder.addCase("raise/error", (state, action) => {
            state.error = action.payload;
        });
        builder.addCase("register/error", (state, action) => {
            state.registerError = action.payload;
        });
    }
});

export const responseReducer = responseSlice.reducer;
